import classNames from "classnames";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { INoteButton } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import NoteButtonsContainer from "./NoteButtonsContainer";

interface IParams {
  noteButtons: INoteButton[];
}

const NotesDropdownContainer: React.FC<IParams> = ({ noteButtons }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const [noteDropdownOpen, setNoteDropdownOpen] = useState(false);

  const toggleNote = () => setNoteDropdownOpen(!noteDropdownOpen);

  return (
    <>
      {noteButtons.length > 1 ? (
        <ButtonDropdown
          isOpen={noteDropdownOpen}
          toggle={toggleNote}
          className={classNames(
            "transparentButton dropdownButton dropdownDiv"
          )}
        >
          <DropdownToggle
            color="none"
            className={classNames(
              " transparentButton dropdownButton",
              `${theme!.toolbarIconColor}`
            )}
          >
            <i className="far fa-sticky-note iconToolbarButton"></i>
            <i className="fas fa-sort-down"></i>
            <h6 className="textToolbarButton mb-0">
              {t("toolbar_notes_dropdown_text")}
            </h6>
          </DropdownToggle>
          <DropdownMenu
            className={classNames(
              "dropdownMenu",
              `${theme!.toolbarBackground}`
            )}
          >
            <NoteButtonsContainer buttons={noteButtons} />
          </DropdownMenu>
        </ButtonDropdown>
      ) : (
        <NoteButtonsContainer buttons={noteButtons} />
      )}
    </>
  );
};

export default NotesDropdownContainer;
